import { createAction } from '@reduxjs/toolkit'

// Standard cart actions
export const checkoutCart = createAction('cart/checkoutCart')
export const clearCart = createAction('cart/clearCart')

/**
 * Add an item to the cart
 * @param {string} variantId - The variant ID to add
 * @param {number} quantity - The quantity to add (defaults to 1)
 * @param {string|null} sellingPlanId - The selling plan ID, if applicable
 * @returns {Object} - Redux action
 */
export const addToCart = createAction('cart/addToCart', (variantId, quantity = 1, sellingPlanId = null) => ({
  payload: {
    variantId,
    quantity,
    ...(sellingPlanId && { selling_plan: sellingPlanId })
  }
}))

// Line item quantity management
export const incrementLineItemQuantity = createAction('cart/incrementLineItemQuantity', variantId => ({
  payload: variantId
}))

export const decrementLineItemQuantity = createAction('cart/decrementLineItemQuantity', variantId => ({
  payload: variantId
}))

/**
 * Remove an item from the cart
 * @param {string} lineItemId - The line item ID to remove (NOT the variant ID)
 * @returns {Object} - Redux action
 */
export const removeFromCart = createAction('cart/removeFromCart', lineItemId => ({
  payload: lineItemId
}))

// Cart action creator for API requests
export const cartActionCreator = createAction('cart/cartActionCreator', promise => ({
  meta: { scope: 'cart' },
  payload: promise
}))

// Shopify checkout ID management
export const saveShopifyCheckoutId = createAction('cart/saveShopifyCheckoutId', (promise, id) => ({
  meta: { id },
  payload: promise
}))

export const removeShopifyCheckoutId = createAction('cart/removeShopifyCheckoutId', promise => ({
  payload: promise
}))

// New actions for Shopify integration
export const syncCartWithShopify = createAction('cart/syncCartWithShopify')

/**
 * Update the cart with data from Shopify
 * @param {Object} cartData - The cart data from Shopify
 * @returns {Object} - Redux action
 */
export const updateCartFromShopify = createAction('cart/updateCartFromShopify', cartData => ({
  payload: cartData
}))
